package com.essntl.features.itinerary.ui.edit_itinerary.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.withStyle
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.uikit.theme.esColorScheme

@Composable
fun ItineraryServicesReorderConnectServiceDialog(
    fromId: String,
    toId: String,
    itineraryServiceList: List<ItineraryServiceModel>,
    isVisible: Boolean,
    onConfirm: () -> Unit,
    onDismissRequest: () -> Unit,
) {
    val fromService = remember(fromId, itineraryServiceList) {
        itineraryServiceList.find { service ->
            service.id == fromId
        }?.service
    }

    val toService = remember(toId, itineraryServiceList) {
        itineraryServiceList.find { service ->
            service.id == toId
        }?.service
    }

    val esColorScheme = esColorScheme

    val annotatedString = remember(
        fromService,
        toService,
        esColorScheme,
    ) {
        buildAnnotatedString {
            append("You are about to connect these services together and the itinerary will be updated. You can disconnect them at any time.")
            appendLine()
            appendLine()
            append("Adding: ")
            withStyle(
                SpanStyle(
                    color = esColorScheme.textPrimary,
                    fontWeight = FontWeight.Bold,
                ),
            ) {
                append(fromService?.title.orEmpty())
            }
            appendLine()
            append("To primary service: ")
            withStyle(
                SpanStyle(
                    color = esColorScheme.textPrimary,
                    fontWeight = FontWeight.Bold,
                ),
            ) {
                append(toService?.title.orEmpty())
            }
            appendLine()
            appendLine()
            append("Would you like to continue?")
        }
    }

    ItineraryServicesReorderDialog(
        title = "Connect services?",
        message = annotatedString,
        isVisible = isVisible,
        onConfirm = onConfirm,
        onDismissRequest = onDismissRequest,
    )
}